
const { ccclass, property } = cc._decorator;


@ccclass
export default class LayoutGrid extends cc.Component {

    @property(cc.Vec2)
    cellSize: cc.Vec2 = cc.Vec2.ZERO
    @property(cc.Integer)//8列
    colNum: number = 8
    @property(cc.Integer)
    spacingX: number = 0
    @property(cc.Integer)
    spacingY: number = 0
    @property(cc.Node)
    prefabNode: cc.Node = null

    @property({ type: cc.Enum(cc.Layout.HorizontalDirection), displayName: "水平方向", serializable: true })
    horizontalDirection: cc.Layout.HorizontalDirection = cc.Layout.HorizontalDirection.RIGHT_TO_LEFT

    getChilds(count: number, defaultActive = true) {
        let childs: cc.Node[] = []
        for (let i = 0; i < count; i++) {
            let node = this._getNode(i, this.node)
            node.name = i.toString()
            childs.push(node)
        }
        if (count < this.node.childrenCount) {
            for (let i = count; i < this.node.childrenCount; i++) {
                this.node.children[i].active = false
            }
        }
        for (let i = 0; i < count; i++) {
            this._setPosByIndex(i, defaultActive)
        }
        this.node.sortAllChildren()
        return childs
    }

    _setPosByIndex(index: number, defaultActive: boolean) {
        if (this.horizontalDirection == cc.Layout.HorizontalDirection.RIGHT_TO_LEFT) {
            let xIndex = Math.floor(index % this.colNum)//第几列
            let yIndex = Math.floor(index / this.colNum)//第几行
            let xPos = -this.cellSize.x / 2 - Math.abs(this.spacingX * xIndex)
            let yPos = -Math.abs(this.spacingY * yIndex)
            let child = this.node.children[index]
            child.position = cc.v2(xPos, yPos)
            child.zIndex = (this.colNum - xIndex) + yIndex * this.colNum
            child.active = defaultActive
        } else {
            let xIndex = Math.floor(index % this.colNum)//第几列
            let yIndex = Math.floor(index / this.colNum)//第几行
            let xPos = this.cellSize.x / 2 + Math.abs(this.spacingX * xIndex)
            let yPos = -Math.abs(this.spacingY * yIndex)
            let child = this.node.children[index]
            child.position = cc.v2(xPos, yPos)
            child.zIndex = index
            child.active = defaultActive
        }
    }

    _getNode(index: number, parent: cc.Node): cc.Node {
        if (parent.childrenCount <= index) {
            var node = cc.instantiate(this.prefabNode)
            node.position = cc.v2(0, 0)
            node.scale = 1
            node.parent = parent
            return this._getNode(index, parent)
        }
        else {
            return parent.children[index]
        }
    }

}